import { render, staticRenderFns } from "./generate-instructive.vue?vue&type=template&id=09c9d059"
import script from "./generate-instructive.vue?vue&type=script&lang=js"
export * from "./generate-instructive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports